// @ts-nocheck
import React, { useContext, Fragment, useEffect, useState } from 'react';
import Logo from './Logo.jsx';
import SerpLogo from '../../assets/SerpLogo/Logo.tsx';
import { Link, useNavigation } from 'react-router-dom';
import { slideToggle } from './../../composables/slideToggle.js';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { LogOut, LogOutAction, refreashToken } from '../../store/Login/loginSlice';
import AppsMenu from './AppsMenu/AppsMenu';
import NotificationIcon from './Notifications/notificationIcon.jsx';
import useGetNtxProfile from '@hooks/NTX/useGetNtxProfile';
import { AppSettings } from '@config/app-settings';
import NeatixModal from '@components/Modal/NeatixModal';
import ChangePassword from '@pages/NTX/Security/Users/ChangePassword.jsx';
import DevTenantSwitcher from '@API/DevTenantSwitcher.tsx';
import OperatingUnitSwitcher from './OperatingUnitSwitcher.tsx';

//_____________________________________________________________

function Header({ themeClass }) {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState();
  const dispatch = useDispatch();
  const { UserProfile: Profile } = useGetNtxProfile();
  const context = useContext(AppSettings);
  const appTopNav = context.appTopNav;
  const appSidebar = context.appSidebarNone;

  const { themeClass: j } = useContext(AppSettings);

  const notificationData = [];

  const toggleAppSidebarDesktop = () => {
    var elm = document.querySelector('.app');
    if (elm) {
      if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
        elm.classList.toggle('app-sidebar-collapsed');

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 150);
      }
    }
  };

  const toggleAppSidebarMobile = () => {
    var elm = document.querySelector('.app');
    if (elm) {
      if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
        elm.classList.toggle('app-sidebar-mobile-toggled');
      } else {
        slideToggle(document.querySelector('.app-top-nav'));
      }
    }
  };

  const toggleAppHeaderSearch = () => {
    var elm = document.querySelector('.app');
    elm.classList.toggle('app-header-menu-search-toggled');
  };

  const handleLogout = async () => {
    // debugger
    try {
      await dispatch(LogOut());
      const res = await dispatch(LogOutAction()).unwrap();
      // debugger;
      // ToastSwal({ icon: 'success', title: res.data || 'Logged out successfully!', position: 'top-start' });
    } catch (error) {
      console.error('Logout failed:', error);
      // ToastSwal({ icon: 'error', title: error.message || 'Logout failed.', position: 'top-start' });
    } finally {
      dispatch(LogOut());
    }
  };

  const handleRefreashToken = async () => {
    // debugger
    try {
      await dispatch(refreashToken());

      // ToastSwal({ icon: 'success', title: res.data || 'Logged out successfully!', position: 'top-start' });
    } catch (error) {
      console.error('Logout failed:', error);
      // ToastSwal({ icon: 'error', title: error.message || 'Logout failed.', position: 'top-start' });
    }
  };

  const nav = useNavigation();
  const loading = nav.state === 'loading';

  return (
    <Fragment>
      <div id='header' className={`app-header ${!appTopNav ? 'shadow border-bottom border-theme' : '  '} `}>
        <>
          <div className='desktop-toggler' hidden={appSidebar}>
            <button type='button' className='menu-toggler' onClick={toggleAppSidebarDesktop}>
              <span className='bar'></span>
              <span className='bar'></span>
              <span className='bar'></span>
            </button>
          </div>
          <div className='mobile-toggler'>
            <button type='button' className='menu-toggler' onClick={toggleAppSidebarMobile}>
              <span className='bar'></span>
              <span className='bar'></span>
              <span className='bar'></span>
            </button>
          </div>
        </>
        <div className='brand'>
          <Link
            className='brand-logo'
            // to="/Neatix/Applications">
            to='/UserDashboard'
            replace
          >
            <Logo themeClass={themeClass} />
            {/* <Logo themeClass={'theme-info'} /> */}
            {/* <SerpLogo /> */}
          </Link>
        </div>

        {/* <div className="brand  mt-1 text-theme text-center ">
          <h6 className="text-theme">{sysCode.name}</h6>
        </div> */}

        <div className='menu'>
          {/* <div className="menu-item dropdown  ">
            <Link to="/Neatix/Applications" className="menu-link">
              <div className="menu-icon">
                <i className="bi bi-grid-3x3-gap nav-icon"></i>
              </div>
            </Link>
          </div> */}

          {/* <TimerToken /> */}
          <AppsMenu />

          <NotificationIcon />

          {/* <DevTenantSwitcher /> */}
          <DevTenantSwitcher />
          {/* <OperatingUnitSwitcher /> */}


          <div className='menu-item dropdown dropdown-mobile-full'>
            <a href='#/' data-bs-toggle='dropdown' data-bs-display='static' className='menu-link'>
              <div className='menu-img online'>
                <div className='d-flex align-items-center justify-content-center w-100 h-100 bg-inverse bg-opacity-25 text-inverse text-opacity-50 rounded-circle overflow-hidden'>
                  {Profile?.personImage === null ? (
                    <img src='../../../assets/img/user/manEmp.png' alt='' width={100} className='rounded-circle' />
                  ) : (
                    <img
                      className='rounded-circle '
                      src={Profile?.personImage?.filePath}
                      alt=''
                      style={{
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%'
                      }}
                    />
                  )}
                </div>
              </div>
              <div className='menu-text d-sm-block d-none w-200px'>
                {i18n.language === 'en' ? Profile?.name : Profile?.name2}
              </div>
            </a>
            <div className='dropdown-menu dropdown-menu-end me-lg-3 fs-11px mt-1'>
              <Link to='/NTX/Profile' className='dropdown-item d-flex align-items-center'>
                {t('Profile')}
                <i className='bi bi-person-circle ms-auto text-theme fs-16px my-n1'></i>
              </Link>

              {/* <Link to='/Neatix/Settings' className='dropdown-item d-flex align-items-center'>
                {t('Settings')}
                <i className='bi bi-gear ms-auto text-theme fs-16px my-n1'></i>
              </Link> */}
              <div className='dropdown-divider'></div>
              {/* <Link
                onClick={() => setShow(true)}
                to=''
                // to='Security/Users/ChangePassword'
                className='dropdown-item d-flex align-items-center'
              >
                {t('ChangePassword')}
                <i className='bi bi-key ms-auto text-theme fs-16px my-n1'></i>
              </Link> */}
              <button className='dropdown-item d-flex align-items-center' onClick={() => setShow(true)}>
                {t('ChangePassword')}
                <i className='bi bi-key ms-auto text-theme fs-16px my-n1'></i>
              </button>

              <Link
                to='/login'
                replace
                onClick={() => handleLogout()}
                className='dropdown-item d-flex align-items-center'
              >
                {t('logout')}
                <i className='bi bi-box-arrow-right ms-auto text-theme fs-16px my-n1'></i>
              </Link>
              {/* <Link
                // to=''
                // replace
                onClick={() => handleRefreashToken()}
                className='dropdown-item d-flex align-items-center'
              >
                {t('تحديث الجلسة')}
                <i className='bi bi-box-arrow-right ms-auto text-theme fs-16px my-n1'></i>
              </Link> */}
            </div>
          </div>

          
        </div>
      </div>

      <NeatixModal show={show} setShow={setShow} size='md' showHeader={false}>
        <ChangePassword onClose={() => setShow(false)} />
      </NeatixModal>

      {loading ? <div className='top-progress'></div> : null}

      <style>{style}</style>
    </Fragment>
  );
}

export default Header;

const style = `
.top-progress {
  position: fixed;
  top: 100;
  left: 0;
  height: 5px;
  width: 100%;
  z-index: 9999;
  pointer-events: none;
}

.top-progress::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 35%;
  background-color:  var(--bs-theme);
  filter: drop-shadow(0 0 10px rgba(59, 130, 246, 0.35));
  animation: topProgressSlide 0.8s ease-in-out infinite;
}

@keyframes topProgressSlide {
  0%   { transform: translateX(-60%); opacity: 0.4; }
  50%  { opacity: 1; }
  100% { transform: translateX(220%); opacity: 0.4; }
}


`;

// {
//   /* <div id='header' className='app-header'>
//       <div className='desktop-toggler'>
//         <button type='button' className='menu-toggler' onClick={toggleAppSidebarDesktop}>
//           <span className='bar'></span>
//           <span className='bar'></span>
//           <span className='bar'></span>
//         </button>
//       </div>

//       <div className='mobile-toggler'>
//         <button type='button' className='menu-toggler' onClick={toggleAppSidebarMobile}>
//           <span className='bar'></span>
//           <span className='bar'></span>
//           <span className='bar'></span>
//         </button>
//       </div>

//       <div className='brand'>
//         <Link to='/' className='brand-logo'>
//           <span className='brand-img'>
//             <span className='brand-img-text text-theme'>H</span>
//           </span>
//           <span className='brand-text'>HUD ADMIN</span>
//         </Link>
//       </div>

//       <div className='menu'>
//         <div className='menu-item dropdown'>
//           <a href='#/' onClick={toggleAppHeaderSearch} className='menu-link'>
//             <div className='menu-icon'>
//               <i className='bi bi-search nav-icon'></i>
//             </div>
//           </a>
//         </div>
//         <div className='menu-item dropdown dropdown-mobile-full'>
//           <a href='#/' data-bs-toggle='dropdown' data-bs-display='static' className='menu-link'>
//             <div className='menu-icon'>
//               <i className='bi bi-grid-3x3-gap nav-icon'></i>
//             </div>
//           </a>
//           <div className='dropdown-menu fade dropdown-menu-end w-300px text-center p-0 mt-1'>
//             <div className='row row-grid gx-0'>
//               <div className='col-4'>
//                 <Link to='/email/inbox' className='dropdown-item text-decoration-none p-3 bg-none'>
//                   <div className='position-relative'>
//                     <i className='bi bi-circle-fill position-absolute text-theme top-0 mt-n2 me-n2 fs-6px d-block text-center w-100'></i>
//                     <i className='bi bi-envelope h2 opacity-5 d-block my-1'></i>
//                   </div>
//                   <div className='fw-500 fs-10px text-inverse'>INBOX</div>
//                 </Link>
//               </div>
//               <div className='col-4'>
//                 <Link to='/pos/customer-order' className='dropdown-item text-decoration-none p-3 bg-none'>
//                   <div>
//                     <i className='bi bi-hdd-network h2 opacity-5 d-block my-1'></i>
//                   </div>
//                   <div className='fw-500 fs-10px text-inverse'>POS SYSTEM</div>
//                 </Link>
//               </div>
//               <div className='col-4'>
//                 <Link to='/calendar' className='dropdown-item text-decoration-none p-3 bg-none'>
//                   <div>
//                     <i className='bi bi-calendar4 h2 opacity-5 d-block my-1'></i>
//                   </div>
//                   <div className='fw-500 fs-10px text-inverse'>CALENDAR</div>
//                 </Link>
//               </div>
//             </div>
//             <div className='row row-grid gx-0'>
//               <div className='col-4'>
//                 <Link to='/helper' className='dropdown-item text-decoration-none p-3 bg-none'>
//                   <div>
//                     <i className='bi bi-terminal h2 opacity-5 d-block my-1'></i>
//                   </div>
//                   <div className='fw-500 fs-10px text-inverse'>HELPER</div>
//                 </Link>
//               </div>
//               <div className='col-4'>
//                 <Link to='/settings' className='dropdown-item text-decoration-none p-3 bg-none'>
//                   <div className='position-relative'>
//                     <i className='bi bi-circle-fill position-absolute text-theme top-0 mt-n2 me-n2 fs-6px d-block text-center w-100'></i>
//                     <i className='bi bi-sliders h2 opacity-5 d-block my-1'></i>
//                   </div>
//                   <div className='fw-500 fs-10px text-inverse'>SETTINGS</div>
//                 </Link>
//               </div>
//               <div className='col-4'>
//                 <Link to='/widgets' className='dropdown-item text-decoration-none p-3 bg-none'>
//                   <div>
//                     <i className='bi bi-collection-play h2 opacity-5 d-block my-1'></i>
//                   </div>
//                   <div className='fw-500 fs-10px text-inverse'>WIDGETS</div>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className='menu-item dropdown dropdown-mobile-full'>
//           <a href='#/' data-bs-toggle='dropdown' data-bs-display='static' className='menu-link'>
//             <div className='menu-icon'>
//               <i className='bi bi-bell nav-icon'></i>
//             </div>
//             <div className='menu-badge bg-theme'></div>
//           </a>
//           <div className='dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1'>
//             <h6 className='dropdown-header fs-10px mb-1'>NOTIFICATIONS</h6>
//             <div className='dropdown-divider mt-1'></div>
//             {notificationData.length > 0 ? (
//               notificationData.map((notification, index) => (
//                 <a
//                   href='#/'
//                   key={index}
//                   className='d-flex align-items-center py-10px dropdown-item text-wrap fw-semibold'
//                 >
//                   <div className='fs-20px'>
//                     <i className={notification.icon}></i>
//                   </div>
//                   <div className='flex-1 flex-wrap ps-3'>
//                     <div className='mb-1 text-inverse'>{notification.title}</div>
//                     <div className='small text-inverse text-opacity-50'>{notification.time}</div>
//                   </div>
//                   <div className='ps-2 fs-16px'>
//                     <i className='bi bi-chevron-right'></i>
//                   </div>
//                 </a>
//               ))
//             ) : (
//               <div className='dropdown-notification-item p-3 text-center'>No record found</div>
//             )}
//             <hr className='mb-0 mt-2' />
//             <div className='py-10px mb-n2 text-center'>
//               <a href='#/' className='text-decoration-none fw-bold'>
//                 SEE ALL
//               </a>
//             </div>
//           </div>
//         </div>
//         <div className='menu-item dropdown dropdown-mobile-full'>
//           <a href='#/' data-bs-toggle='dropdown' data-bs-display='static' className='menu-link'>
//             <div className='menu-img online'>
//               <div className='d-flex align-items-center justify-content-center w-100 h-100 bg-inverse bg-opacity-25 text-inverse text-opacity-50 rounded-circle overflow-hidden'>
//                 <i className='bi bi-person-fill fs-32px mb-n3'></i>
//               </div>
//             </div>
//             <div className='menu-text d-sm-block d-none w-170px'>username@account.com</div>
//           </a>
//           <div className='dropdown-menu dropdown-menu-end me-lg-3 fs-11px mt-1'>
//             <Link to='/profile' className='dropdown-item d-flex align-items-center'>
//               PROFILE <i className='bi bi-person-circle ms-auto text-theme fs-16px my-n1'></i>
//             </Link>
//             <Link to='/email/inbox' className='dropdown-item d-flex align-items-center'>
//               INBOX <i className='bi bi-envelope ms-auto text-theme fs-16px my-n1'></i>
//             </Link>
//             <Link to='/calendar' className='dropdown-item d-flex align-items-center'>
//               CALENDAR <i className='bi bi-calendar ms-auto text-theme fs-16px my-n1'></i>
//             </Link>
//             <Link to='/settings' className='dropdown-item d-flex align-items-center'>
//               SETTINGS <i className='bi bi-gear ms-auto text-theme fs-16px my-n1'></i>
//             </Link>
//             <div className='dropdown-divider'></div>
//             <Link to='/pages/login' className='dropdown-item d-flex align-items-center'>
//               LOGOUT <i className='bi bi-toggle-off ms-auto text-theme fs-16px my-n1'></i>
//             </Link>
//           </div>
//         </div>
//       </div>

//       <form className='menu-search' method='POST' name='header_search_form'>
//         <div className='menu-search-container'>
//           <div className='menu-search-icon'>
//             <i className='bi bi-search'></i>
//           </div>
//           <div className='menu-search-input'>
//             <input type='text' className='form-control form-control-lg' placeholder='Search menu...' />
//           </div>
//           <div className='menu-search-icon'>
//             <a href='#/' onClick={toggleAppHeaderSearch}>
//               <i className='bi bi-x-lg'></i>
//             </a>
//           </div>
//         </div>
//       </form>
//     </div> */
// }
